import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {createStructuredSelector} from 'reselect'

import * as pdp from '../../store/productDetailPage'
import * as reviews from '../../store/reviews'
import * as track from '../../track/track'
import * as URLS from '../../urls'
import * as urlUtils from '../../utils'

import ProductStarRating from './Reviews/ProductStarRating'

const FeaturedReviewsBelt = ({
  averageScore,
  categorySlug,
  productName,
  productUrlSlug,
  totalReviews,
}) => {
  const reviewsUrl = urlUtils.toPath(URLS.PRODUCT_REVIEWS, {
    displayCategory: categorySlug,
    product: productUrlSlug,
  })

  return (
    <div className="featured-reviews-belt-container">
      <div className="featured-reviews-belt-inner">
        <ProductStarRating score={averageScore} />
        <Link
          to={reviewsUrl}
          onClick={() => track.pdpClicked(`${productName} Reviews`, reviewsUrl)}
          className="featured-reviews-belt-review-count"
        >
          {totalReviews} Reviews
        </Link>
      </div>
    </div>
  )
}

FeaturedReviewsBelt.propTypes = {
  averageScore: PropTypes.number.isRequired,
  categorySlug: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  productUrlSlug: PropTypes.string.isRequired,
  totalReviews: PropTypes.number.isRequired,
}

const mapStateToProps = createStructuredSelector({
  averageScore: reviews.averageScore,
  categorySlug: pdp.productCategorySlug,
  productName: pdp.productName,
  productUrlSlug: pdp.productUrlSlug,
  totalReviews: reviews.totalReviews,
})

export default connect(mapStateToProps)(FeaturedReviewsBelt)
